// import { ADDADMIN, ERROR, FORGETPASSWORD } from '../actions/ADDADMIN_action';
import { FETCHMEETINGERROR, FETCHMEETINGREQUEST, FETCHMEETINGSUCCESS } from './../actions/actionTypes'
 
const initialState = {
    requestDone: false,
    isFetched: false,
    isFetching : false,
    err : false,
    message:'',
    meetings: [],
    total : 0,
  };
  
  // receiving response sent by action according to type of action
  export default function allCategoriesReduces(state = initialState, action) {
      //console.log(action,'action')
      let { payload } = action
    switch (action.type) {
        case FETCHMEETINGREQUEST:
          return { 
            requestDone: false,
            isFetched: false,
            isFetching : true,
            err : false,
            message:'',
            meetings: [],
            total : 0
           };
          break;
        case FETCHMEETINGSUCCESS:
        return { 
            requestDone: true,
            isFetched: true,
            isFetching : false,
            err : false,
            message:'',
            meetings: payload.data,
            total : payload.count
        };
        break;
  
        case FETCHMEETINGERROR:
        return { 
            requestDone: true,
            isFetched: false,
            isFetching : false,
            err : true,
            message: payload.message,
            meetings: [],
            total : 0
        };
        break;
      default:
        return state;
    }
  }
